import { readStoredToken, type RefreshOutcome } from '@/api/refreshToken'
import { rememberForcedLogout, reportForcedLogout } from '@/api/authDiagnostics'
import { useAuthStore } from '@/stores/authStore'
import { API_ENDPOINTS, ROUTES } from '@/utils/constants'

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:4545/api'

function redirectToLogin(): void {
  const path = window.location.pathname
  // Страница активации кабинета сама предлагает выйти и после выхода
  // показывает форму: увести с неё на вход значило бы потерять ссылку из письма.
  if (!path.includes('/login') && !path.startsWith(ROUTES.CABINET_ACTIVATE)) {
    window.location.href = '/login'
  }
}

/**
 * Сессия закончилась окончательно: сообщить причину (пока токен ещё есть),
 * запомнить её для prior_state следующего входа, сбросить сессию.
 * Гость (сессии в этой вкладке не было) ничего не сообщает; повторный вызов
 * после выхода — тоже, поэтому общий обмен у нескольких запросов даёт один отчёт.
 */
function forceLogoutToLogin(reason: string): void {
  const state = useAuthStore.getState()
  if (state.isAuthenticated) {
    reportForcedLogout({
      url: `${API_URL}${API_ENDPOINTS.AUTH.CLIENT_EVENTS}`,
      reason,
      token: readStoredToken() ?? state.token,
      userId: state.user?.id ?? null,
    })
    rememberForcedLogout(reason)
  }
  state.logout()
  redirectToLogin()
}

/** Сессию уже завершили в другой вкладке: убрать её следы здесь, без отчёта */
function endSessionLocally(): void {
  useAuthStore.getState().logout()
  redirectToLogin()
}

/**
 * Разобрать итог обмена токена — общий путь для interceptor 401 и продления
 * заранее (useAuthBootstrap). Вкладка, получившая `failed`, единственная
 * сообщает причину выхода: соседние по метке отказа получают `ended`.
 *
 * - `failed` — сообщить причину и выйти;
 * - `ended` — только локальная уборка;
 * - `ok`, `transient` — сессию не трогать.
 */
export function settleRefreshOutcome(outcome: RefreshOutcome): void {
  switch (outcome.status) {
    case 'failed':
      forceLogoutToLogin(outcome.reason)
      break
    case 'ended':
      endSessionLocally()
      break
    case 'ok':
    case 'transient':
      break
  }
}
